// extracted by mini-css-extract-plugin
export default {"vidmask":"WebcamCapture_vidmask__mwfao","video":"WebcamCapture_video__fkSDp","canvas":"WebcamCapture_canvas__MK+mc"};